import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store'
import './assets/css/base.css'
import './assets/js/rem'
import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css'
import i18n from './language'

import globalMethods from './mixins'
Vue.prototype.$layer = layer(Vue, {
  msgtime: 2, // 消失时间
  fixed: true
})

Vue.prototype.data = data
Vue.prototype.$global_config = global_config
Vue.config.productionTip = false
Vue.mixin(globalMethods)

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
